/**
 * Genera una URL de Cloudinary optimizada con transformaciones.
 *
 * @param {string} originalUrl - La URL original de Cloudinary.
 * @param {object} [options] - Las opciones de transformación.
 * @param {number} [options.width] - El ancho deseado de la imagen.
 * @param {number} [options.height] - El alto deseado de la imagen.
 * @param {string} [options.crop='fill'] - El modo de recorte (ej. 'fill', 'fit', 'thumb').
 * @param {string} [options.quality='auto'] - La configuración de calidad (ej. 'auto', 'auto:good').
 * @param {string} [options.format='auto'] - La configuración de formato (ej. 'auto' para webp/avif).
 * @returns {string} La nueva URL con los parámetros de optimización.
 */
export const getOptimizedCloudinaryUrl = (originalUrl, options = {}) => {
  // Si la URL no es de Cloudinary o es nula, la devolvemos sin cambios.
  if (!originalUrl || !originalUrl.includes('res.cloudinary.com')) {
    return originalUrl;
  }

  const {
    width,
    height,
    crop = 'fill',
    quality = 'auto',
    format = 'auto',
  } = options;

  // Construimos la cadena de transformación
  const transformationParts = [];
  if (width) transformationParts.push(`w_${width}`);
  if (height) transformationParts.push(`h_${height}`);
  if (width || height) transformationParts.push(`c_${crop}`); // El recorte solo tiene sentido si hay dimensiones

  transformationParts.push(`q_${quality}`);
  transformationParts.push(`f_${format}`);

  const transformationString = transformationParts.join(',');

  // Insertamos la cadena de transformación en la URL
  return originalUrl.replace('/upload/', `/upload/${transformationString}/`);
};
